// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__vFyY_","buttons":"PendingPaymentAlert_buttons__3dE6Q"};